/**
 *
 * @module adEngineClientEndpoint
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef AdEngineClientEndpoint
 * @type {Object}
 *
 * @property {String} setToken
 * @property {String} setTokenRedirect
 *
 */

/**
 *
 * @enum
 * @type {AdEngineClientEndpoint}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    setToken: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    setTokenRedirect: null
});



// WEBPACK FOOTER //
// ./src/services/media/adEngine/adEngineClientEndpoint.js